import { gql } from "@apollo/client"

export const APPROVE_AUDIO = gql`
    mutation approveAudio($approveAudioInput: ApproveAudioInput) {
        approveAudio(approveAudioInput: $approveAudioInput) {
            fileName
            fileExtension
            binaryData
            size
        }
    }
`
